import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import LandingPage from './pages/LandingPage';
import Pricing from './pages/Pricing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Profile from './pages/Profile';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import PitchDeck from './pages/PitchDeck';
import PartnerDeck from './pages/PartnerDeck';
import Explainer from './pages/Explainer';
import Admin from './pages/Admin';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/pitch" element={<PitchDeck />} />
        <Route path="/partners" element={<PartnerDeck />} />
        <Route path="/how-it-works" element={<Explainer />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </>
  );
}

export default App;
